import { render, staticRenderFns } from "./VaccinationEdit.vue?vue&type=template&id=21423b94&scoped=true&"
import script from "./VaccinationEdit.vue?vue&type=script&lang=js&"
export * from "./VaccinationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21423b94",
  null
  
)

export default component.exports